// src/ai/actionCommands.js

import { db } from '../firebase';
import { collection, query, where, getDocs, doc, updateDoc, addDoc, serverTimestamp } from 'firebase/firestore';
import { invalidateCollections } from '../hooks/useCachedCollection';

// Servis durumu güncelleme
export const handleUpdateServiceStatus = async (command) => {
    const serialNumberMatch = command.match(/(\w+)\s+seri numaralı/);
    const statusMatch = command.match(/durumunu\s+(.+)\s+yap/);

    if (serialNumberMatch && statusMatch) {
        const serialNumber = serialNumberMatch[1].toUpperCase();
        const targetStatusRaw = statusMatch[1].trim();

        const validStatuses = {
            "beklemede": "Beklemede",
            "işlemde": "İşlemde",
            "tamamlandı": "Tamamlandı",
            "teslime hazır": "Teslime Hazır"
        };
        const targetStatus = validStatuses[targetStatusRaw];

        if (!targetStatus) {
            return `"${targetStatusRaw}" geçerli bir durum değil. Lütfen Beklemede, İşlemde, Tamamlandı veya Teslime Hazır durumlarından birini kullanın.`;
        }

        const q = query(collection(db, "serviceRecords"), where("cihazSeriNumarasi", "==", serialNumber));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
            return `${serialNumber} seri numaralı bir servis kaydı bulunamadı.`;
        }
        
        const recordDoc = snapshot.docs[0];
        await updateDoc(doc(db, "serviceRecords", recordDoc.id), { durum: targetStatus });
        await invalidateCollections(['serviceRecords']);
        return `${serialNumber} seri numaralı cihazın durumu başarıyla ${targetStatus} olarak güncellendi.`;
    }
    return null;
};

// Yeni ön görüşme oluşturma (Diyalog Başlangıcı)
export const handleCreatePreInterview = (setConversationState) => {
    setConversationState({
        stage: 'awaiting_name',
        command: 'create_pre_interview',
        data: {},
    });
    return 'Elbette. Müşterinin adı ve soyadı nedir?';
};

// Ön görüşme diyalogunu yönetme
export const processPreInterviewConversation = async (transcript, conversationState, setConversationState) => {
    const { stage, data } = conversationState;
    let nextStage = stage;
    let responseText = '';
    const newData = { ...data };

    if (stage === 'awaiting_name') {
        newData.adSoyad = transcript;
        nextStage = 'awaiting_phone';
        responseText = `${transcript} için telefon numarası nedir?`;
    } else if (stage === 'awaiting_phone') {
        const phone = transcript.replace(/\s/g, ''); // Boşlukları kaldır
        if (!/^\d+$/.test(phone)) {
            responseText = 'Lütfen geçerli bir telefon numarası söyleyin.';
        } else {
            newData.telefon = phone;
            nextStage = 'awaiting_confirmation';
            responseText = `${newData.adSoyad}, telefon ${phone}. Bilgiler doğruysa 'evet' veya 'onayla' deyin.`;
        }
    } else if (stage === 'awaiting_confirmation') {
        if (['evet', 'onayla', 'doğru'].includes(transcript.toLowerCase())) {
            try {
                await addDoc(collection(db, "preInterviews"), {
                    ...newData,
                    durum: 'Yeni',
                    notlar: 'Sesli asistan ile oluşturuldu.',
                    ilgilenilenHizmet: 'Belirtilmedi',
                    olusturmaTarihi: serverTimestamp(),
                });
                responseText = 'Ön görüşme kaydı başarıyla oluşturuldu.';
                nextStage = null; // Diyalogu bitir
            } catch (error) {
                console.error("Ön görüşme kaydedilirken hata:", error);
                responseText = 'Kayıt oluşturulurken bir hata oluştu.';
                nextStage = null;
            }
        } else {
            responseText = 'İşlem iptal edildi.';
            nextStage = null;
        }
    }

    setConversationState(nextStage ? { ...conversationState, stage: nextStage, data: newData } : null);
    return responseText;
};